// Provincies + steden/gemeenten voor België en Nederland.
// Bron: officiële provincie-indelingen. Steden zijn de belangrijkste
// gemeenten per provincie (top 6-10), gesorteerd op inwonertal.

export const REGIONS = {
  BE: {
    label: "België",
    flag: "🇧🇪",
    provinces: {
      Brussel: ["Brussel"],
      Antwerpen: ["Antwerpen", "Mechelen", "Turnhout", "Lier", "Mortsel", "Geel", "Herentals", "Heist-op-den-Berg"],
      "Vlaams-Brabant": ["Leuven", "Vilvoorde", "Halle", "Tienen", "Aarschot", "Diest", "Asse"],
      Limburg: ["Hasselt", "Genk", "Sint-Truiden", "Beringen", "Lommel", "Tongeren", "Bilzen"],
      "Oost-Vlaanderen": ["Gent", "Aalst", "Sint-Niklaas", "Dendermonde", "Geraardsbergen", "Lokeren", "Eeklo", "Oudenaarde"],
      "West-Vlaanderen": ["Brugge", "Kortrijk", "Oostende", "Roeselare", "Ieper", "Waregem", "Knokke-Heist", "Tielt", "Veurne"],
      Henegouwen: ["Bergen (Mons)", "Charleroi", "Doornik (Tournai)", "La Louvière", "Moeskroen", "Aat (Ath)", "Soignies"],
      Luik: ["Luik (Liège)", "Verviers", "Seraing", "Herstal", "Hoei (Huy)", "Eupen"],
      Luxemburg: ["Aarlen (Arlon)", "Bastenaken (Bastogne)", "Marche-en-Famenne", "Aarlen", "Neufchâteau"],
      Namen: ["Namen (Namur)", "Dinant", "Andenne", "Gembloers", "Philippeville"],
      "Waals-Brabant": ["Waver (Wavre)", "Nijvel (Nivelles)", "Ottignies-Louvain-la-Neuve", "Tubeke", "Geldenaken"],
      Andere: ["Andere gemeente in België"],
    },
  },
  NL: {
    label: "Nederland",
    flag: "🇳🇱",
    provinces: {
      Drenthe: ["Assen", "Emmen", "Hoogeveen", "Meppel", "Coevorden"],
      Flevoland: ["Lelystad", "Almere", "Dronten", "Zeewolde", "Urk"],
      Friesland: ["Leeuwarden", "Drachten", "Sneek", "Heerenveen", "Harlingen", "Dokkum"],
      Gelderland: ["Arnhem", "Nijmegen", "Apeldoorn", "Ede", "Doetinchem", "Zutphen", "Tiel", "Harderwijk"],
      Groningen: ["Groningen", "Hoogezand", "Veendam", "Stadskanaal", "Winschoten"],
      Limburg: ["Maastricht", "Heerlen", "Venlo", "Sittard-Geleen", "Roermond", "Weert", "Kerkrade"],
      "Noord-Brabant": ["'s-Hertogenbosch", "Eindhoven", "Tilburg", "Breda", "Helmond", "Bergen op Zoom", "Oss", "Roosendaal"],
      "Noord-Holland": ["Haarlem", "Amsterdam", "Alkmaar", "Hilversum", "Zaanstad", "Haarlemmermeer", "Den Helder", "Purmerend"],
      Overijssel: ["Zwolle", "Enschede", "Hengelo", "Deventer", "Almelo", "Kampen"],
      Utrecht: ["Utrecht", "Amersfoort", "Veenendaal", "Nieuwegein", "Houten", "Zeist"],
      Zeeland: ["Middelburg", "Vlissingen", "Goes", "Terneuzen", "Hulst", "Zierikzee"],
      "Zuid-Holland": ["Den Haag", "Rotterdam", "Leiden", "Dordrecht", "Delft", "Zoetermeer", "Gouda", "Schiedam", "Spijkenisse"],
      Andere: ["Andere gemeente in Nederland"],
    },
  },
};

export const COUNTRIES = [
  { code: "BE", ...REGIONS.BE },
  { code: "NL", ...REGIONS.NL },
];
